import { supabase } from "@/integrations/supabase/client";
import type { QueryData } from "@supabase/supabase-js";

export const templateFieldsQuery = `
  id,
  template_id,
  field_id,
  order_index,
  is_visible,
  field:fields (
    id,
    name,
    type,
    primary_dataset_id,
    secondary_dataset_id,
    filter_id,
    secondary_filter_id,
    dataset:datasets!fields_primary_dataset_id_fkey (
      id,
      name
    )
  ),
  template_field_branching (
    id,
    condition_field_id,
    condition_value,
    datapoint_id,
    datapoint:datapoints (
      id,
      name,
      smart_tags (
        tag_value
      )
    )
  ),
  template_field_filters (
    filter_id,
    is_secondary
  ),
  rule_sets:template_field_rule_sets (
    id,
    name,
    description,
    order_index,
    rules:template_field_rules (
      id,
      field_id,
      datapoint_id,
      order_index,
      datapoint:datapoints (
        id,
        name
      ),
      operator
    )
  )
`;

export const templatesWithFieldsQuery = supabase.from("templates").select(`
          *,
          template_search_terms (
            term
          ),
          template_fields (
            ${templateFieldsQuery}
          )
        `);

export type TemplatesWithFields = QueryData<typeof templatesWithFieldsQuery>;
export type TemplateField = TemplatesWithFields[number]["template_fields"][number];
export type TemplateFieldRuleSet = TemplateField["rule_sets"][number];
export type TemplateFieldRuleSetRules = TemplateFieldRuleSet["rules"];
